import React from 'react';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';

const Card = ({
  children,
  className,
  padding = true,
  hover = false,
  onClick,
  ...props
}) => {
  // Clickable cards must be keyboard-operable
  const interactiveProps = onClick
    ? {
        onClick,
        role: 'button',
        tabIndex: 0,
        onKeyDown: (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick(e);
          }
        }
      }
    : {};

  return (
    <div
      {...interactiveProps}
      className={twMerge(
        clsx(
          'bg-white rounded-xl shadow-sm border border-secondary-200',
          padding && 'p-6',
          hover && 'hover:shadow-md transition-shadow duration-200',
          onClick && 'cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-500',
          className
        )
      )}
      {...props}
    >
      {children}
    </div>
  );
};

const CardHeader = ({ children, className, ...props }) => {
  return (
    <div
      className={twMerge('mb-4 pb-4 border-b border-secondary-200', className)}
      {...props}
    >
      {children}
    </div>
  );
};

const CardTitle = ({ children, className, ...props }) => {
  return (
    <h3
      className={twMerge('text-lg font-semibold text-secondary-900', className)}
      {...props}
    >
      {children}
    </h3>
  );
};

const CardContent = ({ children, className, ...props }) => {
  return (
    <div className={twMerge('text-secondary-700', className)} {...props}>
      {children}
    </div>
  );
};

const CardFooter = ({ children, className, ...props }) => {
  return (
    <div
      className={twMerge('mt-4 pt-4 border-t border-secondary-200', className)}
      {...props}
    >
      {children}
    </div>
  );
};

Card.Header = CardHeader;
Card.Title = CardTitle;
Card.Content = CardContent;
Card.Footer = CardFooter;

export default Card;